  /* eslint-disable */
  import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'

  // GeneralViews
  import NotFound from '../components/GeneralViews/NotFoundPage.vue'
  
  // Dashboard
  import Dashboard from 'src/components/Dashboard/Views/bp-dashboard/base-dashboard.vue'
  
  // New Employee
  import newEmployee from 'src/components/Dashboard/Views/bp-new-employee/base-new-employee.vue'
 
  // Calendar Event
  import calendar from 'src/components/Dashboard/Views/bp-calendar/base-calendar.vue'
  import holidays from 'src/components/Dashboard/Views/bp-calendar/base-holidays.vue'
  import addCalendarEvent from 'src/components/Dashboard/Views/bp-calendar/base-add-calendar-event.vue'

  // Employee List
  import employeeList from 'src/components/Dashboard/Views/bp-employee-management/base-employee-list.vue'
  import editInfo from 'src/components/Dashboard/Views/bp-employee-management/base-edit-info.vue'
  
  //NTE Request
  import nteRequest from 'src/components/Dashboard/Views/bp-employee-management/base-nte-request.vue'
  import nteRequestForm from 'src/components/Dashboard/Views/bp-employee-management/base-nte-request-form.vue'
  import nteApprovalRequest from 'src/components/Dashboard/Views/bp-employee-management/base-nte-approval.vue'
  import noticeForDecision from 'src/components/Dashboard/Views/bp-employee-management/base-notice-for-decision.vue'
  import nteViewDetails from 'src/components/Dashboard/Views/bp-employee-management/base-nte-view-details.vue'
  import nteEditRequest from 'src/components/Dashboard/Views/bp-employee-management/base-nte-edit-request.vue'
  import nteManualInput from 'src/components/Dashboard/Views/bp-employee-management/base-nte-manual-input.vue'

  //Coaching Record
  import coachingRecords from 'src/components/Dashboard/Views/bp-employee-management/base-coaching-record.vue'
  import coachingRecordsDetails from 'src/components/Dashboard/Views/bp-employee-management/base-employee-coached-details.vue'

  // Work Shifts
  import WorkShifts from 'src/components/Dashboard/Views/bp-employee-management/base-work-shifts.vue'

  // Schedule Adjustment 
  import ScheduleAdjustment from 'src/components/Dashboard/Views/bp-employee-management/base-schedule-adjustment.vue'
  import ScheduleAdjustmentForm from 'src/components/Dashboard/Views/bp-employee-management/base-adjustment-form.vue'
  import ScheduleEditAdjustmentForm from 'src/components/Dashboard/Views/bp-employee-management/base-edit-schedule-adjustment.vue'

  // UnderTime Request 
  import UndertimeRequest from 'src/components/Dashboard/Views/bp-employee-management/base-undertime-request.vue'
  import UndertimeRequestForm from 'src/components/Dashboard/Views/bp-employee-management/base-undertime-form'
  import EditUndertimeRequestForm from 'src/components/Dashboard/Views/bp-employee-management/base-edit-undertime-request'

  // Dependents
  import Dependents from 'src/components/Dashboard/Views/bp-employee-management/base-dependents.vue'
  import DependentForm from 'src/components/Dashboard/Views/bp-employee-management/base-dependents-form.vue'
  import EditDependentForm from 'src/components/Dashboard/Views/bp-employee-management/base-edit-dependents.vue'
  
  // Resigned
  import Resigned from 'src/components/Dashboard/Views/bp-employee-management/base-resigned.vue'

  // Contact Info
  import contactInfo from 'src/components/Dashboard/Views/bp-contact-info/base-contact-info.vue'
 
  // Employee Requirements
  import employeeRequirements from 'src/components/Dashboard/Views/bp-requirements/base-requirements.vue'
 
  // Job Information
  import jobinformation from 'src/components/Dashboard/Views/bp-job-information/base-job-information.vue'
  import inactive from 'src/components/Dashboard/Views/bp-job-information/base-inactive.vue'
  import viewJobinformation from 'src/components/Dashboard/Views/bp-job-information/base-view-job-information.vue'
  
  // Department
  import department from 'src/components/Dashboard/Views/bp-departments/base-department.vue'
  // Sub Department
  import subDepartment from 'src/components/Dashboard/Views/bp-departments/base-sub-department.vue'
  
  // Position
  import position from 'src/components/Dashboard/Views/bp-positions/base-position.vue'
  
  // Absence Leave
  import absenceLeave from 'src/components/Dashboard/Views/bp-leave-management/base-leave-management.vue'
  import requestLeave from 'src/components/Dashboard/Views/bp-leave-management/base-request-leave.vue'
  import leaveApproval from 'src/components/Dashboard/Views/bp-leave-management/base-leave-approval.vue'
  import leaveCredits from 'src/components/Dashboard/Views/bp-leave-management/base-leave-credits'
  import viewLeave from 'src/components/Dashboard/Views/bp-leave-management/base-view-leave.vue'
  import updateLeave from 'src/components/Dashboard/Views/bp-leave-management/base-update-leave'
  
  // Time and Attendance
  import timeAttendance from 'src/components/Dashboard/Views/bp-time-attendance/base-time-attendance.vue'

  // Payroll
  import payslip from 'src/components/Dashboard/Views/bp-payroll/base-payslip.vue'
  import uploadPayslip from 'src/components/Dashboard/Views/bp-payroll/base-upload-payslip.vue'

  // Responsibility Form 
  import responsibilityForm from 'src/components/Dashboard/Views/bp-responsibility-form/base-responsibility-form.vue'
  import viewResponsibility from 'src/components/Dashboard/Views/bp-responsibility-form/base-view-responsibility.vue'
  import addResponSibilityForm from 'src/components/Dashboard/Views/bp-responsibility-form/base-add-responsibility-form.vue'
  import EditResponsibilityForm from 'src/components/Dashboard/Views/bp-responsibility-form/base-edit-responsibility.vue'
 
  //WFH Responsibility
  import wfhResponsibility from 'src/components/Dashboard/Views/bp-responsibility-form/base-wfh-responsibility.vue'
  import viewWfhResponsibility from 'src/components/Dashboard/Views/bp-responsibility-form/base-view-wfh-responsibility.vue'

  // Perfomance
  import performance from 'src/components/Dashboard/Views/bp-performance/base-performance.vue'

  // Perfomance Details
  import performanceDetails from 'src/components/Dashboard/Views/bp-performance/base-performance-details.vue'
  
  // Employee Account
  import employeeAccount from 'src/components/Dashboard/Views/bp-employee-accounts/base-employee-account.vue'
 
  // Reports
  import reports from 'src/components/Dashboard/Views/bp-reports/base-reports.vue'

  //Contracts and Memos
  import contractsMemo from 'src/components/Dashboard/Views/bp-contracts-memo/base-contracts-memo.vue'
  import AssignContracts from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-contracts.vue'
  import AssignMemos from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-memos.vue'
  import AssignContractsAll from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-contracts-all.vue'
  import AssignMemosAll from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-memos-all.vue'
  import AssignMemosCdHw from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-memos-cd-hw.vue'
  import AssignMemosCdPq from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-memos-cd-pq.vue'
  import AssignMemosMantra from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-memos-mantra.vue'
  import AssignMemosVaNzAu from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-memos-va-nz-au.vue'
  import AssignMemosVaUs from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-memos-va-us.vue'
  import AssignMemosCollections from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-memos-collections.vue'
  import AssignMemosAdmin from 'src/components/Dashboard/Views/bp-contracts-memo/base-assign-memos-admin.vue'

  // Users
  import users from 'src/components/Dashboard/Views/bp-users/base-users.vue'
  import accountUser from 'src/components/Dashboard/Views/bp-users/base-account-user.vue'
  import groupAccess from 'src/components/Dashboard/Views/bp-users/base-group-access.vue'
  import supervisorAccess from 'src/components/Dashboard/Views/bp-users/base-supervisor-account.vue'
  import assistantManager from 'src/components/Dashboard/Views/bp-users/base-assistant-manager.vue'

  // User Roles
  import userRoles from 'src/components/Dashboard/Views/bp-user-roles/base-user-roles.vue'
  import createRoles from 'src/components/Dashboard/Views/bp-user-roles/base-create-roles.vue'
 
  // Settings
  import settings from 'src/components/Dashboard/Views/bp-settings/base-settings.vue'
  import notificationConfig from 'src/components/Dashboard/Views/bp-settings/base-notification-config.vue'
  import creditConfig from 'src/components/Dashboard/Views/bp-settings/base-credit-config.vue'

  // Login and Register Pages
  import LoginLayout from 'src/components/auth/layout-login.vue'
  import layoutPasswordNew from 'src/components/auth/layout-new-password.vue'
  import layoutPasswordReset from 'src/components/auth/layout-password-reset.vue'
  import Logout from 'src/components/auth/logout.vue'

  //Employee Contributions 

  import contributionsDetails from 'src/components/Dashboard/Views/bp-contributions/base-contributions-details.vue'
  import contributionsForm from 'src/components/Dashboard/Views/bp-contributions/base-contributions-form.vue'
  import contributionsList from 'src/components/Dashboard/Views/bp-contributions/base-contributions-list.vue'

  const routes = [

   // LOGIN FORM 
   {
    path: '/',
    name: 'Login-Layout',
    component: LoginLayout,
  },

   // PASSWORD RESET FORM 
   {
    path: '/reset/password',
    name: 'password-resert-layout',
    component: layoutPasswordReset,
  },
  {
    path: '/new/password/:token',
    name: 'layout-password-new',
    component: layoutPasswordNew,
  },
  // LOGOUT ROUTE
   {
      path: '/logout',
      name: 'Logout-Layout',
      component: Logout
   },

   // Page route
   {
     path: '/hr',
     component: DashboardLayout,
     redirect: '/hr/dashboard',
     children: [
        //Dashboard
        {
          path: 'dashboard',
          name: 'Dashboard',
          component:Dashboard,
          meta: { requiresAuth: true, roles:['hr']},
           
        },
        //Employee Contributions
        {
          path: 'contributions/list',
          name: 'contributions-list',
          component:contributionsList,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'contributions/form',
          name: 'contributions-form',
          component:contributionsForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'contributions/details/:id/:employee_id',
          name: 'contributions-details',
          component:contributionsDetails,
          meta: { requiresAuth: true, roles:['hr']}  
        },
         //New Employee
        {
          path: 'newemployee',
          name: 'new-employee',
          component:newEmployee,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Employee List
        {
          path: 'employeelist',
          name: 'employee-list',
          component:employeeList,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Calendar Event
        {
          path: 'calendar',
          name: 'calendar',
          component:calendar,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'holidays',
          name: 'holidays',
          component:holidays,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'addcalendarevent',
          name: 'add-calendar-event',
          component:addCalendarEvent,
          meta: { requiresAuth: true, roles:['hr']}  
        },
         //Work Shifts
         {
          path: 'workshifts',
          name: 'work-shifts',
          component:WorkShifts,
          meta: { requiresAuth: true, roles:['hr']}  
        },
         
         //NTE Request
         {
          path: 'nterequest',
          name: 'nte-request',
          component:nteRequest,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'nterequestform',
          name: 'nte-request-form',
          component:nteRequestForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'nteapprovalrequest/:id',
          name: 'nte-approval-request',
          component:nteApprovalRequest,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'notice/for/decision/:id',
          name: 'notice-for-decision',
          component:noticeForDecision,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'nte/view/details/:id',
          name: 'nte-view-details',
          component:nteViewDetails,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'nteeditrequest/:id',
          name: 'nte-edit-request',
          component:nteEditRequest,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'ntemanualinput',
          name: ' nte-manual-input',
          component:nteManualInput,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Coaching Records
        {
          path: 'coaching/records',
          name: ' coaching-records',
          component:coachingRecords,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'coaching/records/details/:id',
          name: 'coaching-records-details',
          component:coachingRecordsDetails,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Schedule Adjustment
        {
          path: 'scheduleadjustment',
          name: 'schedule-adjustment',
          component:ScheduleAdjustment,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'adjustmentform',
          name: 'adjustment-form',
          component:ScheduleAdjustmentForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'schedule/edit/adjustment/form/:id',
          name: 'schedule-edit-adjustment-form',
          component:ScheduleEditAdjustmentForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },
         //Undertime Request
         {
          path: 'undertimerequest',
          name: 'undertime-request',
          component:UndertimeRequest,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'undertimeform',
          name: 'undertime-form',
          component:UndertimeRequestForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'editundertimerequestform/:id',
          name: 'edit-undertime-request-form',
          component:EditUndertimeRequestForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },
       
        //Dependents
        {
          path: 'dependents',
          name: 'dependents',
          component:Dependents,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Dependent form
        {
          path: 'dependentform',
          name: 'dependents-form',
          component:DependentForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Dependent Edit form
        {
          path: 'editdependent/:id',
          name: 'edit-dependent',
          component:EditDependentForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },

         //Resigned
         {
          path: 'resigned',
          name: 'resigned',
          component:Resigned,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'editinfo/:id',
          name: 'edit-info',
          component:editInfo,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Contact info
        {
          path: 'contactinfo',
          name: 'contact-info',
          component:contactInfo,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Requirements
        {
          path: 'requirements',
          name: 'requirements',
          component:employeeRequirements,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Departments
        {
          path: 'department',
          name: 'department',
          component:department,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Sub Departments
         {
          path: 'subdepartment',
          name: 'sub-department',
          component:subDepartment,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Position
        {
          path: 'position',
          name: 'position',
          component:position,
          meta: { requiresAuth: true, roles:['hr']}  
        },
       //Absenceleave
        {
          path: 'absenceleave',
          name: 'absence-leave',
          component:absenceLeave,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'requestleave',
          name: 'request-leave',
          component:requestLeave,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'viewleave',
          name: 'view-leave',
          component:viewLeave,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'leave/approval/:id',
          name: 'leave-approval',
          component:leaveApproval,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'update/leave/:id',
          name: 'update-leave',
          component:updateLeave,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'leavecredits',
          name: 'leave-credits',
          component:leaveCredits,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //Time Attendance
        {
          path: 'timeattendance',
          name: 'time-attendance',
          component:timeAttendance,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        // Payroll
        {
          path: 'payslip',
          name: 'payslip',
          component:payslip,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'payslip/upload/:id',
          name: 'uploadPayslip',
          component:uploadPayslip,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        // Responsibility form
        {
          path: 'responsibilityform',
          name: 'responsibility-form',
          component:responsibilityForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'viewresponsibility/:id',
          name: 'view-responsibility',
          component:viewResponsibility,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'addresponsibilityform',
          name: 'add-responsibility-form',
          component:addResponSibilityForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'editresponsibilityform',
          name: 'edit-responsibility-form',
          component:EditResponsibilityForm,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //WFH Responsibility
        {
          path: 'wfh/responsibility',
          name: 'wfh-responsibility',
          component:wfhResponsibility ,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'view/wfh/responsibility/:id',
          name: 'view-wfh-responsibility',
          component:viewWfhResponsibility,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        // Job Information
        {
          path: 'jobinformation',
          name: 'job-information',
          component:jobinformation,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'viewjobinformation/:id',
          name: 'view-job-information',
          component:viewJobinformation,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'inactive',
          name: 'in-active',
          component:inactive,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        // Performance
        {
          path: 'performance',
          name: 'performance',
          component:performance,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        // Performance
        {
          path: 'performancedetails/:id',
          name: 'performance-details',
          component:performanceDetails,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        // Employee Account
        {
          path: 'employeeaccount',
          name: 'employee-account',
          component:employeeAccount,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        // Reports
        {
          path: 'reports',
          name: 'reports',
          component:reports,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for contracts memo
        {
          path: 'contractsmemo',
          name: 'contracts-memo',
          component:contractsMemo,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for assigning contracts
        {
          path: 'contracts/assign/:id',
          name: 'assign-contracts',
          component:AssignContracts,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for assigning memos
        {
          path: 'memos/assign/:id',
          name: 'assign-memos',
          component:AssignMemos,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for assigning contracts to all
        {
          path: 'contracts/assign-all',
          name: 'assign-contracts-all',
          component:AssignContractsAll,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for assigning memos to all
        {
          path: 'memos/assign-all',
          name: 'assign-memos-all',
          component:AssignMemosAll,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for assigning memos to CD-HW
        {
          path: 'memos/assign-cd-hw',
          name: 'assign-memos-cd-hw',
          component:AssignMemosCdHw,
          meta: { requiresAuth: true, roles:['hr']}  
        },
         //route for assigning memos to CD-PQ
         {
          path: 'memos/assign-cd-pq',
          name: 'assign-memos-cd-pq',
          component:AssignMemosCdPq,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for assigning memos to Mantra
        {
          path: 'memos/assign-mantra',
          name: 'assign-memos-mantra',
          component:AssignMemosMantra,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for assigning memos to Va - NZAU
        {
          path: 'memos/assign-va-nz-au',
          name: 'assign-memos-va-nz-au',
          component:AssignMemosVaNzAu,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for assigning memos to Va - US
        {
          path: 'memos/assign-va-us',
          name: 'assign-memos-va-us',
          component:AssignMemosVaUs,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for assigning memos to Collections
        {
          path: 'memos/assign-collections',
          name: 'assign-memos-collections',
          component:AssignMemosCollections,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        //route for assigning memos to Admin
        {
          path: 'memos/assign-admin',
          name: 'assign-memos-admin',
          component:AssignMemosAdmin,
          meta: { requiresAuth: true, roles:['hr']}  
        },
         // Users
        {
          path: 'users',
          name: 'users',
          component:users,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'accountuser',
          name: 'account-user',
          component:accountUser,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'groupaccess',
          name: 'group-access',
          component:groupAccess,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'supervisoraccess',
          name: 'supervisor-access',
          component:supervisorAccess,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'assistantmanager',
          name: 'assistant-manager',
          component:assistantManager,
          meta: { requiresAuth: true, roles:['hr']}  
        },
         // User Roles
         {
          path: 'usersroles',
          name: 'users-roles',
          component:userRoles,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'createroles',
          name: 'create-roles',
          component:createRoles,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        // Settings
        {
          path: 'settings',
          name: 'settings',
          component:settings,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'notificationconfig',
          name: 'notification-config',
          component:notificationConfig,
          meta: { requiresAuth: true, roles:['hr']}  
        },
        {
          path: 'creditconfig',
          name: 'credit-config',
          component:creditConfig,
          meta: { requiresAuth: true, roles:['hr']}  
        }
     ]
   },
   { path: '*', component: NotFound }
]

export default routes


// WEBPACK FOOTER //
// ./src/routes/routes.js